import userInfo from 'hub-http/userInfo';
import { initializeAuth } from './AppActions';
export function getAuth() {
  return async dispatch => {
    const info = await userInfo({
      ignoreRedirect: true
    });
    return dispatch(initializeAuth(info));
  };
}